import { uiblockerStyle } from '@bingads-webui-campaign-react/common-styles';

export const getExtensionsStepStyles = (_, theme = { palette: {} }) => ({
  '@global': {
    ...uiblockerStyle(theme),
  },

  stepContainer: {
    width: '100%',
  },
  'stepContainer-xl': {
    width: '430px',
  },
  'stepContainer-xxl': {
    width: '530px',
  },

  stepDescription: {
    marginBottom: 30,
  },

  collapsiblePanel: {
    border: 'none',
    marginBottom: 'unset',
    backgroundColor: 'unset',
    '& .panel-heading': {
      padding: 0,
      borderBottom: 'none',
      marginBottom: 18,

      '& .panel-title': {
        fontSize: 18,
        '& > a': {
          marginLeft: '-8px', // compensate 8px padding on the left of icon
          color: theme.palette.themePrimary,
          padding: 0,
          '&:hover, &:active': {
            color: theme.palette.themeDarker,
            textDecoration: 'none',
            backgroundColor: 'unset',
          },
        },

        '& > a:after': {
          transform: 'rotate(180deg)',
        },

        '& > a.collapsed:after': {
          transform: 'rotate(90deg)',
        },
      },
    },

    '& .panel-collapse': {
      '& .panel-body': {
        padding: 0,
        overflow: 'hidden',
      },
    },
  },
});
